import { Vue } from 'vue-property-decorator';
import WeatherOptionLine from './chart-option/weather-option-line';
import { WeatherData } from '@/interfaces/weather_interface';

// 建模仿真
export enum dataIESType {
    time = '日期',
    t10m = '环境温度（℃）',
    lwgab_swgdn = '太阳辐射强度（W/m2）',
    tsoil3 = '土壤平均温度（℃）',
    u10m = '距地面10m处东向风速（m/s）',
    u50m = '距地面50m处东向风速（m/s）',
    v10m = '距地面10m处北向风速（m/s）',
    v50m = '距地面50m处北向风速（m/s）',
}

// 天气新数据格式
export enum dataWeatherNewType {
    time = '日期',
    t10m = '环境温度（℃）',
    tsoil3 = '土壤平均温度（℃）',
    u10m = '距地面10m处东向风速（m/s）',
    u50m = '距地面50m处东向风速（m/s）',
    v10m = '距地面10m处北向风速（m/s）',
    v50m = '距地面50m处北向风速（m/s）',
    adj_sfc_sw_direct_all_1h = '短波直射强度（W/m²）',
    adj_sfc_sw_diff_all_1h = '短波散射强度（W/m²）',
    solar_zen_angle_1h = '太阳天顶角°',
}

/**
 * 天气模块基础类
 */
export default class Weather_Base extends Vue {
    /**
     * 年数据列表
     */
    yearSource = [2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021].map((x) => {
        return {
            value: x,
            label: `${x}年`,
        };
    });
    /** 月数据列表 */
    monthSource = new Array(12).fill('').map((_x, index) => {
        return { value: index + 1, label: `${index + 1}月` };
    });

    /** 时间绑定 */
    timeData = { year: 2021, month: 1, day: 1 };

    /** 日数据列表 */
    get daySource(): Array<{ value: number; label: string }> {
        const d = new Date(this.timeData.year, this.timeData.month, 0);
        const length = d.getDate();
        return new Array(length).fill('').map((x, index) => {
            return { value: index + 1, label: `${index + 1}日` };
        });
    }

    /** 天气数据表 */
    weather_data: WeatherData[] = [];

    /** 天气数据缓存表 */
    weather_data_cache: WeatherData[] = [];

    /** 图表默认option */
    weatherOption = {
        ...WeatherOptionLine,
        xAxis: {
            type: 'category',
            data: new Array(24).fill('').map((x, index) => {
                return `${index}h`;
            }),
            axisPointer: {
                type: 'shadow',
            },
            axisLabel: {},
        },
        toolbox: {
            feature: {
                magicType: { show: true, type: ['line', 'bar'], title: { line: '切换为曲线图' } },
                restore: { show: true },
                saveAsImage: { show: true },
            },
            right: '2%',
            top: 0,
        },
    };

    /** 天气坐标 */
    weather_coordinates = {
        lat: 10,
        lng: 10,
    };
}
